import {Button, Col, Divider, PageHeader, Row} from "antd";
import React, {useCallback, useEffect, useState} from "react";
import {PlusOutlined} from "@ant-design/icons";
import moment, {Moment} from "moment";
import {AttendanceStepEntity} from "../../attendance/domain/entity/attendance-step.entity";
import {ModalAttendanceWizardComponent} from "../component/modal.attendance-wizard.component";
import {Route, Switch, useHistory, useRouteMatch} from "react-router-dom";
import {ModulePageProps} from '../../../core/module-pages';
import {ModalAttendanceStepComponent} from "../component/modal.attendance-step.component";
import {ModalAttendanceComponent} from "../component/modal.attendance.component";
import {BusinessCalendarComponent} from "../component/business-calendar";
import {DrawerStepActionComponent} from "../component/drawer-step-action";
import {InsightsDashboardComponent} from "../component/insights.dashboard.component";
import {useAttendanceStepRepository} from "../../../../../domain/repository/attendance-step.repository";
import {PendingStepsComponent} from "../component/pending-steps.component";
import {FinanceEntriesComponent} from "../component/finance-entries.component";
import {JbTabComponent, JbTabsComponent} from "../../../core/component/jb-tabs.component";
import {FullBusinessCalendar} from "../component/full-calendar";
import {JbPageHeaderComponent} from "../../../core/component/jb-page-header.component";

export function DashboardIndex(props: ModulePageProps) {
  const [attendanceSteps, setAttendanceSteps] = useState<AttendanceStepEntity[]>([])
  const [dateParams, setDateParams] = useState<string[]>([])
  const [listAllAttendances, setListAllAttendances] = useState(false);
  const [daySelected, setDaySelected] = useState<Moment>(moment())
  const [createAttendance, setCreateAttendance] = useState(false);
  const [cellSelected, setCellSelected] = useState<Moment>();
  const attendanceStepRepo = useAttendanceStepRepository();
  const routeMatch = useRouteMatch();
  const history = useHistory();
  
  useEffect(() => onCalendarDateChange(daySelected), [])
  
  function loadData() {
    if (!dateParams.length) return;
    const [beginDate, endDate] = dateParams;
    attendanceStepRepo
      .listAllStepsByPeriod(beginDate, endDate, false, false)
      .then(res => setAttendanceSteps(res.data.filter(w => !w.finished)))
  }
  
  useEffect(() => {
    loadData();
  }, [dateParams, listAllAttendances])
  
  
  function convertDateToParams(dt: Moment) {
    const [refYear, refMonth] = dt.toISOString(true).split(/[-T]/)
    const [nextYear, nextMonth] = dt.add(1, 'month').toISOString(true).split(/[-T]/)
    return [
      `${refYear}-${refMonth}-01`,
      `${nextYear}-${nextMonth}-01`,
    ]
  }
  
  function onCalendarDateChange(dt: Moment) {
    setDaySelected(dt.clone());
    setDateParams(convertDateToParams(dt.clone()))
  }
  
  function goToAttendance(id: string) {
    props.navigator(
      `attendance/${id}`
    )
  }
  
  function onSelect(date: Moment) {
    setCellSelected(date);
    onCalendarDateChange(date);
  }
  
  const onStepView = useCallback((step: AttendanceStepEntity)  => {
    props.navigator(`attendance/${step.attendanceId}/step/${step.id}`)
  }, [props])
  
  return (
    <>
      <JbPageHeaderComponent
        title={'Visão Geral'}
        description={'Gestão das Movimentações Registradas no Sistema'}
        hideDivider
        extraActions={[
          <Button
            onClick={() => setCreateAttendance(true)}
            size={'large'}
            shape={'round'}
            type={'primary'}
            icon={<PlusOutlined />}
          >
            Atendimento
          </Button>
        ]}
      />
      
      <JbTabsComponent>
        <JbTabComponent title={'Calendáro'} key={'calendar'}>
          <FullBusinessCalendar 
            steps={attendanceSteps} 
            onStepClick={onStepView}
          />
        </JbTabComponent>
        <JbTabComponent title={'Próximas Movimentações'} key={'next-steps'}>
          <PendingStepsComponent
            onStepClick={onStepView}
            currentUserSelected={false}
          />
        </JbTabComponent>
        <JbTabComponent title={'Lançamentos Pendentes'} key={'next-entries'}>
          <FinanceEntriesComponent />
        </JbTabComponent>
      </JbTabsComponent>
      <>
        {
          createAttendance && (
            <ModalAttendanceWizardComponent
              visible={true}
              onCancel={() => {
                loadData();
                setCreateAttendance(false)
              }}
              navigator={props.navigator as any}
            />
          )
        }
        {
          cellSelected && (
            <DrawerStepActionComponent
              currentDate={cellSelected}
              steps={attendanceSteps}
              onViewStep={onStepView}
              onCancel={() => setCellSelected(undefined)}
            />
          )
        }
        {
          <Switch>
            <Route path={`${routeMatch.path}attendance/:id/step/:stepId`} strict={false}>
              <ModalAttendanceStepComponent
                oinAttendanceLink={
                  id => goToAttendance(id)
                }
                onClose={() => {
                  loadData()
                  history.push(props.prefix)
                }}
              />
            </Route>
            <Route path={`${routeMatch.path}attendance/:id`} strict={false}>
              <ModalAttendanceComponent
                onClose={() => {
                  loadData()
                  history.push(props.prefix)
                }}
              />
            </Route>
          </Switch>
        }
      </>
    </>
  )
}